import { alpha, Box } from '@mui/material';
import React, { useState } from 'react';
import { AlertRuleScreenProps } from 'components/alert-rule-popup/index';
import { Trans, useTranslation } from 'react-i18next';
import AlertRuleCriteria from 'components/alert-rule-popup/parts/AlertRuleCriteria';
import AlertRuleMethod from 'components/alert-rule-popup/parts/AlertRuleMethod';
import { prepareFormElementProps } from 'components/common/form/formTools';
import { FormDataAPIType, RawFormComponentType } from 'components/common/form';
import useCustomSimplifiedForm from 'components/common/form/hooks/useCustomSimplifiedForm';
import FormStaticInfo from 'components/common/form/layout/static/FormStaticInfo';
import AlertRuleSimulationControl from 'components/alert-rule-popup/parts/AlertRuleSimulationControl';

interface AlertRuleScreenCriteriaProps extends AlertRuleScreenProps {
    onChange?: (text: any) => void;
}

export default function AlertRuleScreenCriteria(props: AlertRuleScreenCriteriaProps) {
    const { alertRuleData, wizardData, updateAlertRuleData = () => {}, updateWizardData = () => {} } = props;
    const { t } = useTranslation(['components/alert-rule-popup/alert_rule_popup']);

    const [criteriaHtmlText, setCriteriaHtmlText] = useState<any>();
    const [kpiHtmlText, setKpiHtmlText] = useState<any>();
    const elementProps: FormDataAPIType = useCustomSimplifiedForm();

    return (
        <Box>
            <Box
                sx={{
                    border: '1px solid',
                    borderColor: (theme) => alpha(theme.palette.text.primary, 0.08),
                    padding: 1.5,
                    backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.02),
                    borderRadius: '4px',
                }}
            >
                <AlertRuleCriteria
                    {...props}
                    onChange={(newVal) => {
                        setCriteriaHtmlText(newVal);
                    }}
                />
                {wizardData.isKpi && (
                    <Box>
                        <AlertRuleMethod
                            alertRuleData={alertRuleData}
                            wizardData={wizardData}
                            updateAlertRuleData={updateAlertRuleData}
                            updateWizardData={updateWizardData}
                            onChange={(newVal) => {
                                setKpiHtmlText(newVal);
                            }}
                        />
                    </Box>
                )}
            </Box>

            {wizardData.isKpi && (
                <>
                    {wizardData.isShowWarningAlertRulePhone && (
                        <Box sx={{ mt: 2 }}>
                            <FormStaticInfo
                                elementProps={prepareFormElementProps({
                                    ...elementProps,
                                    component: {
                                        label: t('form.criteria.warning_alert_rule_phone'),
                                        props: {
                                            type: 'error',
                                        },
                                    } as RawFormComponentType,
                                })}
                            />
                        </Box>
                    )}
                    <AlertRuleSimulationControl {...props} />
                </>
            )}

            <Box
                sx={{
                    border: '1px solid',
                    borderColor: (theme) => alpha(theme.palette.text.primary, 0.08),
                    px: 1.5,
                    py: 1,
                    backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.02),
                    borderRadius: '4px',
                    mt: 2,
                }}
            >
                <Box>
                    {alertRuleData.alert_type != 'compound' && <>{criteriaHtmlText} </>}
                    {wizardData.isKpi && kpiHtmlText && (
                        <Box
                            component={'span'}
                            sx={{
                                '.mark': {
                                    color: 'error.main',
                                },
                            }}
                            dangerouslySetInnerHTML={{ __html: kpiHtmlText }}
                        />
                    )}

                    {wizardData.showAlertSimulationText && (
                        <>
                            {' '}
                            <Trans
                                t={t}
                                i18nKey="form.criteria.alert_simulation_text"
                                values={{
                                    rawName: wizardData?.dashboardElement?.raw_name ?? '',
                                    triggerCount: wizardData.simulationTriggerCount ?? '',
                                    triggerDate: wizardData.simulationTriggerDate ?? '',
                                }}
                                className={'dAlertSimulationText'}
                            >
                                placeholder_prefix
                                <Box component="span" color="error.main" sx={{ display: 'none' }}>
                                    placeholder_rawName
                                </Box>
                                placeholder_middle
                                <Box component="span" color="error.main" className={'dSimulationTriggerCount'}>
                                    placeholder_triggerCount
                                </Box>
                                placeholder_middle2
                                <Box component="span" color="error.main" className={'dSimulationTriggerDate'}>
                                    placeholder_triggerDate
                                </Box>
                            </Trans>
                        </>
                    )}
                </Box>
            </Box>
        </Box>
    );
}
